import { createContext, useContext } from 'react';
import { SelectFilterDef, NumberRangeFilterDef } from '@tanstack/react-table';

export interface TableFilterMetaEntry {
  options?: SelectFilterDef['options'];
  ranges?: NumberRangeFilterDef['ranges'];
}

export type TableFilterMeta = Record<string, TableFilterMetaEntry>;

export interface DataTableContextValue {
  filters: TableFilterMeta;
}

export const DataTableContext = createContext<DataTableContextValue>({
  filters: {},
});

export const useDataTableContext = () => useContext(DataTableContext);
